import React from 'react';
import { Plus } from 'lucide-react';

export default function CreateFilterModal({
    editingFilter,
    newFilterName,
    onNameChange,
    onClose,
    onSave,
}) {
    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/50 backdrop-blur-sm p-4 animate-in fade-in duration-200">
            <div className="bg-white rounded-xl shadow-xl w-full max-w-md p-6 animate-in zoom-in-95 duration-200 relative">
                <button
                    type="button"
                    aria-label="Close"
                    onClick={onClose}
                    className="absolute top-4 right-4 text-gray-400 hover:text-gray-600"
                >
                    <Plus className="w-5 h-5 rotate-45" /> {/* Using Plus rotated 45deg as Close icon if X isn't imported, or simple X if I import it. I'll stick to Plus rotate for simplicity or update import in next step if needed. Actually I can just render Plus rotate-45 */}
                </button>

                <h2 className="text-xl font-bold text-gray-900 mb-1">{editingFilter ? 'Rename filter' : 'Create new filter'}</h2>
                <p className="text-sm text-gray-500 mb-6">{editingFilter ? 'Update the name of your filter.' : 'Give your filter a name to easily identify it later.'}</p>

                <div className="space-y-4">
                    <div>
                        <label htmlFor="filter-name" className="block text-sm font-medium text-gray-700 mb-1">
                            Filter Name
                        </label>
                        <input
                            id="filter-name"
                            type="text"
                            placeholder="e.g. Webflow Projects"
                            value={newFilterName}
                            onChange={(e) => onNameChange(e.target.value)}
                            onKeyDown={(e) => e.key === 'Enter' && onSave()}
                            className="w-full px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-blue-500 outline-none transition-all"
                        />
                    </div>

                    <div className="flex justify-end gap-3 pt-2">
                        <button
                            type="button"
                            onClick={onClose}
                            className="px-4 py-2 text-sm font-medium text-gray-700 hover:bg-gray-50 rounded-lg transition-colors"
                        >
                            Cancel
                        </button>
                        <button
                            type="button"
                            onClick={onSave}
                            disabled={!newFilterName.trim()}
                            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg shadow-sm transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
                        >
                            {editingFilter ? 'Save Changes' : 'Create Filter'}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    );
}
